import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyH2 } from '~/core/ui/Heading'
import { TextButton } from '~/core/ui/TextButton'
import LPContainer from './LPContainer'
import { useRouter } from 'next/router'
import {
  ATTRACT_SOURCE_URL,
  HIRE_ANALYTICS_URL,
  TRACK_COLLABORATE_URL
} from '~/core/constants/url'

const ApplicantTrackingCRMExploreSection: FCC<{ className?: string }> = ({
  className
}) => {
  const router = useRouter()
  const { t } = useTranslation()
  return (
    <div
      className={`overflow-hidden my-[100px] tablet:my-[164px] ${className}`}>
      <LPContainer>
        <div className="flex-1 flex flex-col justify-center max-w-3xl mx-auto items-center text-center">
          <TypographyH2 className="mt-3 text-center text-4xl tablet:text-4.5xl font-normal">
            {t('applicant_tracking_crm:explore:title')}
          </TypographyH2>
        </div>

        <div className="mt-8 tablet:mt-14 flex flex-col gap-5">
          <div className="flex gap-5 flex-col tablet:flex-row">
            <div className="bg-[#F6F9FE] border border-transparent rounded-xl pt-6 relative">
              <div className="absolute bottom-6 flex items-center justify-center left-0 right-0 space-y-1 flex-col">
                <div className="font-medium text-xl">
                  {t('applicant_tracking_crm:explore:explore01')}
                </div>
                <TextButton
                  size="lg"
                  iconMenus="ArrowUpRight"
                  icon="trailing"
                  label={`${t('applicant_tracking_crm:explore:see_more')}`}
                  onClick={() => {
                    router.push(ATTRACT_SOURCE_URL)
                  }}
                />
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/explore01.png'}
                alt="explore01"
                className="h-auto w-full"
              />
            </div>
            <div className="bg-[#F6F9FE] border border-transparent rounded-xl pt-6 relative">
              <div className="absolute bottom-6 flex items-center justify-center left-0 right-0 space-y-1 flex-col">
                <div className="font-medium text-xl">
                  {t('applicant_tracking_crm:explore:explore02')}
                </div>
                <TextButton
                  size="lg"
                  iconMenus="ArrowUpRight"
                  icon="trailing"
                  label={`${t('applicant_tracking_crm:explore:see_more')}`}
                  onClick={() => {
                    router.push(TRACK_COLLABORATE_URL)
                  }}
                />
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/explore02.png'}
                alt="explore02"
                className="h-auto w-full"
              />
            </div>
            <div className="bg-[#F6F9FE] border border-transparent rounded-xl pt-6 relative">
              <div className="absolute bottom-6 flex items-center justify-center left-0 right-0 space-y-1 flex-col">
                <div className="font-medium text-xl">
                  {t('applicant_tracking_crm:explore:explore03')}
                </div>
                <TextButton
                  size="lg"
                  iconMenus="ArrowUpRight"
                  icon="trailing"
                  label={`${t('applicant_tracking_crm:explore:see_more')}`}
                  onClick={() => {
                    router.push(HIRE_ANALYTICS_URL)
                  }}
                />
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/explore03.png'}
                alt="explore03"
                className="h-auto w-full"
              />
            </div>
          </div>
        </div>
      </LPContainer>
    </div>
  )
}

export default ApplicantTrackingCRMExploreSection
